import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";

// Page imports
import HomePage from "@/pages/Home";
import CDPPage from "@/pages/CDP";
import MessagingPage from "@/pages/Messaging";
import AnalyticsPage from "@/pages/Analytics";
import ContactPage from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import CustomerAcquisitionPage from "@/pages/CustomerAcquisition";
import PoliticalAdvocacyPage from "@/pages/PoliticalAdvocacy";
import CustomerActivationPage from "@/pages/CustomerActivation";
import AboutUsPage from "@/pages/AboutUs";
import MeetUsPage from "@/pages/MeetUs";
import CareersPage from "@/pages/Careers";
import BlogPage from "@/pages/Blog";
import CaseStudyPage from "@/pages/CaseStudy";
import HowItWorksPage from "@/pages/HowItWorks";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cdp" element={<CDPPage />} />
        <Route path="/omnichannel" element={<MessagingPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/customer-acquisition" element={<CustomerAcquisitionPage />} />
        <Route path="/political-advocacy" element={<PoliticalAdvocacyPage />} />
        <Route path="/customer-activation" element={<CustomerActivationPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/meet-us" element={<MeetUsPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPage />} />
        <Route path="/case-study/:slug" element={<CaseStudyPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
      </Routes>
    </Router>
  );
}

export default App;
